<template>
  <div>
    <component
      :is="config.component"
      v-if="config.component"
      :config="getSettings()"
    />
  </div>
</template>

<script>
import * as colors from '@/_core/util/themeUtility';
export default {
  name: 'ErrorHandler',
  components: {
    snackbar: () => import('@/components/ErrorHandler/Snackbar.vue'),
    modal: () => import('@/components/Modal.vue'),
    imageModal: () => import('@/components/ImageModal.vue'),
    alert: () => import('@/components/ErrorHandler/Alert.vue'),
  },
  props: {
    config: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      customCSS: {},
      settingsObj: {
        snackbar: {
          title: '',
          enabled: false,
          content: '',
          color: '',
          timeout: 2000,
          topPosition: true,
          rightPosition: true,
          bottomPosition: false,
          leftPosition: false,
        },
        modal: {
          enabled: false,
          name: 'rui',
          values: '',
          saveButton: 'OK',
          close: true,
          title: '',
          'max-height': '50px',
          width: '650px',
          persistent: false,
          hideToolbar: true,
          deletePopup: true,
          alignCenter: true,
        },
        imageModal: {
          enabled: false,
          name: 'rui',
          values: '',
          saveButton: 'OK',
          close: true,
          title: '',
          'max-height': '50px',
          width: '650px',
          persistent: false,
          status: null,
          hideToolbar: true,
        },
        alert: {
          enabled: false,
          content: '',
          color: '',
          icon: '',
          timeout: 2000,
          topPosition: true,
          rightPosition: true,
          name: 'alert',
          close: true,
          title: '',
          'max-height': '50px',
          width: '650px',
          persistent: false,
        },
      },
      colorMap: {
        alert: {
          error: {
            color: '#EF9A9A',
            icon: 'mdi-alert-circle-outline',
          },
          success: {
            color: '#66BB6A', // green lighten-1
            icon: 'mdi-check-circle-outline',
          },
          info: {
            color: '#B3E5FC',
            icon: 'mdi-information-outline',
          },
          warning: {
            color: '#FFF3E0', // green lighten-1
            icon: 'mdi-alert-outline',
          },
        },
        snackbar: {
          error: {
            color: 'rgba(214, 0, 64, 0.03)', // red
            icon: 'mdi-alert-circle-outline',
          },
          success: {
            color: 'rgb(102, 187, 106)', // green
            icon: 'check',
          },
          info: {
            color: 'rgb(105, 78, 214)', // purple
            icon: 'info',
          },
          warning: {
            color: 'rgb(255, 96, 10)', // orange
            icon: 'mdi-alert-outline',
          },
          custom: {
            color: '#694ED6',
            icon: 'mdi-alert-circle-outline',
          },
        },
        modal: {
          error: {
            color: '#E57373', // red lighten-2
            icon: 'mdi-alert-circle-outline',
          },
          success: {
            color: '#66BB6A', // green lighten-1
            icon: 'mdi-check-circle-outline',
          },
          info: {
            color: '#2196F3', // blue
            icon: 'mdi-information-outline',
          },
          warning: {
            color: '#66BB6A', // green lighten-1
            icon: 'mdi-alert-outline',
          },
        },
      },
    };
  },
  created() {
    this.customCSS = colors.colors;
  },
  methods: {
    getColorByType(component, messageType) {
      return this.colorMap[component][messageType].color;
    },
    getIconByType(component, messageType) {
      return this.colorMap[component][messageType].icon;
    },
    getSettings() {
      const {
        content,
        type,
        title,
        component,
        saveButton = 'Ok',
        cancelButton = 'Cancel',
        timeout,
        payload,
        saveCallback,
        cancelCallback,
        close,
        persistent,
        icon,
        color,
        messageProperty,
        status,
        hideToolbar = true,
        showDivider = false,
        alignCenter = true,
        rounded = true,
        deletePopup = false,
      } = this.config;
      const settingObj = this.settingsObj[component];
      const getColorCode = type ? this.getColorByType(component, type) : color;
      const getIcon = type ? this.getIconByType(component, type) : icon;

      if (settingObj) {
        settingObj.enabled = true;

        if (component === 'modal') {
          settingObj.values = content;
          settingObj.title = title;
          settingObj.saveButton = saveButton;
          settingObj.cancelButton = cancelButton;
          settingObj.saveCallback = saveCallback;
          settingObj.cancelCallback = cancelCallback;
          settingObj.close = close;
          settingObj.persistent = persistent;
          settingObj.payload = payload;
          settingObj.icon = messageProperty ? getIcon : '';
          settingObj.color = messageProperty ? getColorCode : '';
          settingObj.hideToolbar = hideToolbar;
          settingObj.showDivider = showDivider;
          settingObj.alignCenter = alignCenter;
          settingObj.rounded = rounded;
          settingObj.deletePopup = deletePopup;
          settingObj.deletePopup = deletePopup;
        } else if (component === 'snackbar') {
          settingObj.content = content;
          settingObj.color = this.customCSS[`snackbar-${type}`] || getColorCode;
          settingObj.timeout = timeout;
          settingObj.icon = getIcon;
          settingObj.title = title;
          settingObj.type = type;
        } else if (component === 'alert') {
          settingObj.title = title;
          settingObj.content = content;
          settingObj.color = messageProperty ? getColorCode : '';
          settingObj.timeout = timeout;
          settingObj.icon = messageProperty ? getIcon : '';
        } else if (component === 'imageModal') {
          settingObj.title = title;
          settingObj.content = content;
          settingObj.status = status;
        }
      }
      return settingObj;
    },
  },
};
</script>
